export default {"src":"/_next/static/media/paused_light.889b81f8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};